import { render, staticRenderFns } from "./inventory-report.vue?vue&type=template&id=58c84a6a&"
import script from "./inventory-report.vue?vue&type=script&lang=js&"
export * from "./inventory-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports